import { type Translated } from '@myre/common-i18n';
import {
  createEntityAdapter,
  type EntityAdapter,
  type EntityState,
} from '@ngrx/entity';

export enum NotificationStatus {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

export interface Notification {
  id: number;
  message: Translated;
  status: NotificationStatus;
  fadein: boolean;
  hover: boolean;
}

export interface NotificationsState extends EntityState<Notification> {
  counter: number;
}

export const adapter: EntityAdapter<Notification> =
  createEntityAdapter<Notification>();

const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const notificationSelectors = {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
};
